import { DependencyList, useEffect } from "react";

export const useEffectAsync = (effect: () => Promise<void> | (() => void), deps?: DependencyList) => {
    return useEffect(() => {
        (async () => {
            return effect();
        })();
    }, deps);
};
